var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('joy',{attrs:{"config":_vm.w.config}})}
var staticRenderFns = []

export { render, staticRenderFns }